import styled, { keyframes, css } from 'styled-components';
import { Button, Modal } from 'antd';
import * as palette from '../../styles/variables';

export const Container = styled.div`
  height: 100%;
  padding-left: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #fff;
  @media (max-width: 425px) {
    padding-left: 0px !important;
  }
`;

export const SettingpageConatiner = styled.div`
  margin-left: 5%;
  width: 95%;
  height: 100%;
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
  @media (max-width: 425px) {
    width: 100%;
    margin-top: 80px;
    margin-left: 0%;
  }
`;

export const UserConatiner = styled.div`
  max-width: 1400px;
  width: 100%;
`;

export const SidenavContainer = styled.aside`
  width: 300px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  padding-top: 10px;
  @media (max-width: 768px) {
    height: auto;
  }
  @media (max-width: 425px) {
    padding-left: 0px !important;
  }
`;

export const Detailwrapper = styled.div`
  width: 100%;
  height: 100%;
  margin-left: 3rem;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  .card_cover_div {
    padding-bottom: 2rem;
    @media (max-width: 768px) {
      margin-bottom: 6rem;
    }
  }
  .availableLanguages {
    margin-bottom: 24px;
    .ant-select-selection--multiple {
      border: none;
      outline: none;
      box-shadow: none;
      cursor: default;
    }
    .ant-select-search--inline .ant-select-search__field {
      display: none;
    }
  }
  .avatar {
    min-width: 32px;
    min-height: 32px;
  }
`;

export const SidebarTab = styled.div`
  padding: 10px;
  margin: 5px 0px;
  font-size: 14px;
  font-weight: bold;
  color: #121212;
  cursor: pointer;
  white-space: nowrap;
  text-transform: capitalize;
  background: ${props => (props.active ? '#0606060d' : '#fff')};
  display: ${props => props.textToSpeech && 'flex'};
  .anticon {
    font-size: 18px;
    padding: 0px 10px;
  }
  &:hover {
    background: #0606060d;
  }
  i {
    width: 38px;
    height: 18px;
    svg {
      width: ${props => !props.textToSpeech && '100%'};
      height: ${props => !props.textToSpeech && '100%'};
    }
  }
`;
export const DefaultDomain = styled.div`
display: flex;
align-items: center;
color: rgb(107,141,214);
font-weight: 600;
letter-spacing: 0.3px;
column-gap:60px;
`

export const DetailsCard = styled.div`
  display: flex;
  align-items: center;
  background: #f6f6f6;
  padding: 12px !important;
  margin: 0;
  width: 90%;
  height: ${props => (props.smtp ? '65px' : props.user ? '' : 'fit-content')};
  min-height: ${props => props.user && '75px !important'};
  margin: ${props => (props.user ? '10px 0px' : '')};
  border-radius: 4px;
  border: ${props => (props.user ? '1px solid #e8e8e8' : '')};
  font-size: 14px;
  padding: ${props => (props.smtp ? '0px 5px' : '0px 15px')};
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
  i.anticon.anticon-info-circle {
    margin-right: 15px;
    margin-left: -5px;
    font-size: 15px;
    color: rgb(148, 144, 144);
  }
  .default {
    margin-bottom: 5px;
    width: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    text-transform: uppercase;
    font-weight: 700;
  }
  .ant-tag {
    margin-left: 12px;
    padding: 0 18px;
    border-radius: 18px;
    font-weight: 700;
    line-height: 28px;
    .anticon svg {
      margin-right: 6px;
    }
  }
  .add_user_btn {
    font-weight: 500;
    font-size: 12px;
    text-transform: uppercase;
    height: 35px;
    padding: 10px 20px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    background: ${palette.APP_BRAND_YELLOW_COLOR};
    border-radius: 20px;
    color: rgb(0, 0, 0);
    text-shadow: none;
    border: 2px solid transparent;
  }
  .ant-btn.changeSMTP.ant-btn-primary {
    background: #000;
    border: #000;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }
  .ant-btn-primary:hover, .ant-btn-primary:focus {
    color: rgb(0, 0, 0);
    background: ${palette.APP_BRAND_YELLOW_COLOR};
    border-color:${palette.APP_BRAND_YELLOW_COLOR};
}
`;

export const ActionButton = styled.div`
// margin-right:40px;
i.anticon.anticon-info-circle {
  font-size: 15px;
  color: rgb(148, 144, 144);
}
.default {
  margin-bottom: 5px;
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 700;
}
.ant-tag {
  margin-left: 12px;
  padding: 0 18px;
  border-radius: 18px;
  font-weight: 700;
  line-height: 28px;
  .anticon svg {
    margin-right: 6px;
  }
}
.add_user_btn {
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  height: 35px;
  padding: 10px 20px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  background: ${palette.APP_BRAND_YELLOW_COLOR};
  border-radius: 20px;
  color: rgb(0, 0, 0);
  text-shadow: none;
  border: 2px solid transparent;
}
.ant-btn.changeSMTP.ant-btn-primary {
  background: #000;
  border: #000;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}
.ant-btn-primary:hover, .ant-btn-primary:focus {
  color: rgb(0, 0, 0);
  background: ${palette.APP_BRAND_YELLOW_COLOR};
  border-color:${palette.APP_BRAND_YELLOW_COLOR};
}
`

export const UserProfilecover = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: ${props => (props.permission || props.efax) && 'space-between'};
  p {
    font-weight: bold;
    font-size: 14px;
    padding-left: 10px;
  }
  .avatar {
    background-color: #87d068;
  }
`;

export const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 10px;
`;
export const RoleSection = styled.div`
  display: flex;
  align-items: center;
  padding-left: 5px;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 8px;
  .ant-tag {
    margin: 0;
    padding: 0 6px;
    border-width: 2px;
    border-radius: 4px;
  }
`;

export const SidebarHeadCover = styled.div`
  display: flex;
  padding: 25px 0px;
  align-items: center;
  font-size: 14px;
  h5 {
    font-weight: 600;
    letter-spacing: 0.4px;
  }
  p {
    color: rgba(30, 41, 51, 0.45);
    font-weight: 400;
    font-size: 14px;
    line-height: 1.8;
  }
  .avatar {
    background-color: #db391f;
    font-size: 20px;
  }
`;

export const SidebarUserDetail = styled.div`
  padding-left: 12px;
`;

export const DropdownDetails = styled.div`
  background-color: rgb(239 239 239 / 0%);
  color: #000000;
  width: 30px;
  height: 25px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  &:hover {
    background-color: #000;
    color: #fff;
  }
  .anticon-more {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(90deg);
  }
  .ant-dropdown {
    top: 20px !important;
    right: 2px !important;
    left: initial !important;
    .ant-dropdown-menu {
      min-width: 100px;
    }
    .ant-dropdown-menu-item {
      font-weight: bold;
      font-size: 14px;
      padding: 6px 12px;
      margin: 1px 0px;
    }
  }
`;

export const UserDetailHeadingCover = styled.div`
  display: flex;
  width: ${props => (props.separator ? '100%' : props.faxAcc ? '80%' : '90%')};
  align-items: center;
  justify-content: space-between;
  padding: ${props =>
    props.separator ? '25px 0px 0px 0px' : props.textToSpeech ? '25px 0px 0px 0px' : '25px 0px'};
  h5 {
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0.4px;
    line-height: 32px;
  }
  p {
    font-size: 14px;
  }
  .ldap_config {
    margin: 12px;
    margin-left: 0;
    margin-right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: ${props => (props.isPrinter ? '50%' : props.shortMsg ? '30%' : '65%')};
    width: fit-content;
    border: 2px solid #000;
    border-radius: 25px;
    background: #000;
    color: #fff;
    cursor: pointer;
    p {
      padding: 7px;
      text-transform: uppercase;
      font-size: 10.5px;
      letter-spacing: 0.5px;
    }
    .anticon.anticon-plus,
    .anticon.anticon-edit {
      background: #797878;
      color: #fff;
      padding: 5px;
      border-radius: 15px;
      font-size: 12px;
    }
  }
  .add_user_btn {
    font-weight: 500;
    font-size: 12px;
    text-transform: uppercase;
    height: 35px;
    padding: 10px 20px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    background: ${palette.APP_BRAND_YELLOW_COLOR};
    border-radius: 20px;
    color: rgb(0, 0, 0);
    text-shadow: none;
    border: 2px solid transparent;
  }
  .ant-btn.changeSMTP.ant-btn-primary {
    background: #000;
    border: #000;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }
  .sso-switch {
    height: 30px;
  }
  .sso-switch .ant-switch-inner {
    color: #000;
    font-size: 12px;
    font-family: ${palette.FONT_FAMILY_LANDPAGE} !important;
    font-weight: 700;
    margin-right: 10px;
    margin-left: 35px;
  }
  .sso-switch.ant-switch-checked .ant-switch-inner {
    margin-right: 35px;
    margin-left: 10px;
  }
  .sso-switch.ant-switch-checked {
    background-color: #ffeb3b !important;
  }
  .sso-switch.ant-switch::after {
    width: 26px;
    height: 26px;
  }
  .sso-switch.ant-switch-checked::after {
    width: 26px;
    height: 26px;
  }
`;

export const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UserEditCover = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  .mailId {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const StorageCards = styled.div`
  display: flex;
  flex: initial;
  flex-direction: column;
  padding: 10px;
  border-radius: 6px;
  border-bottom: ${props =>
    props.resourceCard ? '1px solid rgb(223, 225, 228)' : '1px solid rgb(239, 241, 244)'};
  box-shadow: ${props => (props.resourceCard ? 'rgb(0 0 0 / 3%) 0px 2px 5px' : '')};
  background-color: ${props => (props.resourceCard ? '#ffffff' : 'rgb(248, 249, 251)')};
  flex-basis: 31%;
  margin: 15px 15px 15px 0px;
  .description {
    font-size: 13px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 0px;
  }
  .card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    div {
      display: flex;
      align-items: center;
    }
    p {
      margin-left: 12px;
      color: rgb(40, 42, 48);
      font-weight: 600;
      font-size: 15px;
    }
  }
  &:hover {
    box-shadow: ${props => (props.resourceCard ? 'rgb(0 0 0 / 9%) 0px 3px 12px' : '')};
  }
  .anticon {
    color: rgb(107, 111, 118);
    &:hover {
      color: #000;
    }
  }
`;

export const StorageHead = styled.h5`
  color: rgb(40, 42, 48);
  font-weight: 600;
  font-size: 17px;
  letter-spacing: -0.01em;
  margin: 0px 0px 10px;
`;

export const StorageButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 4px;
  margin: 5px 0px;
  font-weight: 500;
  min-width: ${props => (props.language ? '100px' : '90px')};
  height: ${props => (props.language ? '35px' : '28px')};
  text-transform: ${props => props.language && 'uppercase'};
  border-radius: ${props => props.language && '20px'};
  padding: 0px 8px;
  font-size: 12px;
  border: 1px solid rgb(223, 225, 228);
  box-shadow: rgb(0 0 0 / 7%) 0px 1px 1px;
  background: ${props => (props.language ? '#000' : 'rgb(255, 255, 255)')};
  color: ${props => (props.language ? '#fff' : ' rgb(60, 65, 73)')};
  span {
    font-size: 13px !important;
  }
  &:hover,
  &:active,
  &:focus {
    background: ${props => (props.language ? '#000' : 'rgb(244, 245, 248) !important')};
    border-color: rgb(201, 203, 205) !important;
    color: ${props => (props.language ? '#fff' : 'rgb(60, 65, 73) !important')};
  }
`;

export const StorageCardContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  column-gap: ${props => props.isStorageCards && '12px'};
  padding: ${props => props.isStorageCards && '10px 0 0 5px'};
  row-gap: ${props => props.isStorageCards && '12px'};
  .googleAPIkey {
    width: 70%;
    .ant-input-lg {
      height: 35px;
      padding: 6px 11px;
      font-size: 14px;
    }
  }
  .active-card {
    background: aliceblue;
    box-shadow: 0px 0px 8px 0px #008DFF;
      div {
        img {
        filter: grayscale(0) !important;
      }
      .default-label {
        background: burlywood;
      }
      }
  }
`;

export const ServicesCards = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 144px;
  min-width: 248px;
  background: #f2f2f2;
  padding: 18px 20px 8px 20px;
  border-radius: 18px;
  cursor: pointer;
  div {
    img {
      width: auto;
      height: 32px;
      filter: grayscale(1);
    }
    &:last-child {
      display: flex;
      justify-content: end;
    }
    p {
      font-weight: 700;
      padding-block: 10px;    
    }
    .default-label {
      background: lightgray;
      border-radius: 16px;
      padding: 2px 20px;
      font-weight: 600;
      font-size: 14px;
    }
    .ant-btn {
      font-family: 'Open Sans' !important;
    }
  }
`;

export const LineSeparator = styled.div`
  width: 100%;
  border-top: 1px solid rgb(239, 241, 244);
  margin: 20px 0px;
`;

export const ResourceSelector = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgb(223, 225, 228);
  padding: 7px 12px;
  margin: 10px 5px;
  border-radius: 3px;
  cursor: pointer;
  div {
    display: flex;
    align-items: center;
  }
  p {
    margin-left: 12px;
    color: rgb(40, 42, 48);
    font-weight: 600;
    font-size: 15px;
  }
`;

export const ImageIconWrapper = styled.div`
  img {
    height: 32px;
  }
`;

export const ListView = styled.ul`
  display: flex;
  flex-direction: row;
  flex-flow: row wrap;
  width: 90%;
  li {
    padding: 0px 10px;
  }
`;

export const InputContainer = styled.div`
  position: relative;
  margin-bottom: ${props => (props.TextToSpeech ? '' : '10px')};
  width: ${props => (props.full ? '100%' : props.TextToSpeech ? '45%' : '80%')};
  .form_btn {
    text-align: center;
    // margin: 20px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .ant-btn,
  .ant-btn[disabled] {
    color: #fff !important;
    background: #000 !important;
    border-color: #000;
    width: 45%;
    height: 40px;
    border-radius: 20px;
    text-transform: uppercase;
    font-size: 12px;
    // margin: 10px;
  }
  .help-text {
  font-size: 12px;
  }
  .ant-input{
    font-weight: 500;
  }
`;

export const InputLabel = styled.h5`
  color: rgb(40, 42, 48);
  font-weight: 600;
  font-size: 14px;
  margin: 10px;
  margin-left: ${props => (props.fax || props.googleConfig) && '0'};
`;

export const JsonBody = styled.pre`
     background-color: #f6f8fa;
     padding: 10px;
     border-radius: 5px;
     overflow: auto;
     min-height: 300px;
     max-height: 300px;
    scrollbar-width: none;
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.25);
    background-color: #f5f5f5;
    cursor: not-allowed;
    opacity: 1;
    border: 1px solid #d9d9d9;
    white-space: pre-wrap;
    ::-webkit-scrollbar {
      display: none;
    }
    
`;

export const UsersList = styled.div`
  display: grid;
  column-gap: 50px;
  grid-template-columns: repeat(auto-fit, 160px);
  justify-content: flex-start;
  margin-left: 5%;
  @media only screen and (max-width: 750px) {
    column-gap: 75px;
    grid-template-columns: repeat(auto-fit, 210px);
  }
`;

export const NoUser = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-left: 6%;
`;

export const ColorLegend = styled.div`
  display: flex;
  width: 100%;
  align-items: center;

  &::before {
    content: '';
    width: 10px;
    height: 10px;
    margin-right: 10px;
    background: ${props => (props.write ? 'rgb(107, 141, 214)' : 'rgb(239, 157, 67)')};
    border-radius: 50%;
  }
`;

export const TeamDetailsCard = styled.div`
 margin-top:${props => (props.teams && "20px")}; 
  @media (max-width: 768px) {
    .ant-collapse {
      margin-bottom: 6rem;
    }
  }
  .ant-collapse .ant-collapse-item-disabled > .ant-collapse-header,
  .ant-collapse .ant-collapse-item-disabled > .ant-collapse-header > .arrow {
    color: #000 !important;
    cursor: auto !important;
  }
  .ant-collapse {
    background-color: transparent;
    border: 1px solid transparent;
    width:${props => (props.teams ? "100%" : " 91%")}; 
  }
  .ant-collapse > .ant-collapse-item.ant-collapse-no-arrow > .ant-collapse-header {
    display: flex;
    align-items: center;
  }
  .ant-collapse-content {
    border-top: 1px solid transparent;
    background: #f6f6f6;   
    overflow: auto;
    ::-webkit-scrollbar {
      display: none;
    }
  }
  .ant-collapse > .ant-collapse-item.ant-collapse-no-arrow > .ant-collapse-header {
    background: #f6f6f6;
  }
  // .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  //   background: #f6f6f6;
  // }
  .ant-collapse > .ant-collapse-item {
    border: 1px solid #e8e8e8;
    margin: ${props => (props.smtp ? '5px' : props.printer ? '5px' : '10px')};
    border-radius: 4px;
  }
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding: 0;
    padding-left: 40px;
  }
  .ant-radio-wrapper {
    margin-right: 15px;
  }
  .userName {
    padding: 10px;
    width: 160px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media only screen and (min-width: 1440px) {
      width: 210px;
    }
    @media only screen and (min-width: 2560px) {
      width: 360px;
    }
  }
  .read_access {
    color: rgb(239, 157, 67);
    font-weight: 600;
    letter-spacing: 0.3px;
  }
  .write_acess {
    color: rgb(107, 141, 214);
    font-weight: 600;
    letter-spacing: 0.3px;
  }
  .defaultSmtp {
    text-align: center;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 4px;
    margin: 8px;
    margin-left: 5px;
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    border: 2px solid #ee9c49;
    background: #fbead9;
    color: #ee9c49;
    cursor: pointer;
    position: relative;
  }
  .anticon-delete.disabled {
    pointer-events: none;
  }
  .anticon-edit.disabled {
    pointer-events: none;
  }
  .PageIcon {
    cursor: pointer;
    .anticon.anticon-loading {
      font-size: ${props => props.printer && '18px'};
    }
  }
  .anticon.anticon-printer {
    font-size: ${props => props.printer && '18px'};
  }
  .isValidPrinter {
    position: absolute;
    font-size: 14px;
    top: -6px;
    right: -6px;
  }
  .page {
    top: -2px;
    right: -2px;
  }
  .ant-collapse-item:last-child > .ant-collapse-content {
    width:100%;
  }
  .addressList{
  margin-top:10px;
  }
`;
export const ChangeSmtpRadio = styled.div`
  width: 250px !important;
  font-size: 13px;
`;

export const FlexContainter = styled.div`
   display:flex;
   justify-content: ${props => (props.sb && "space-between")};
   gap: ${props => (props.gap && "10px")};
   margin-top:${props => (props.mt && "20px")};
   align-items:center;

   .verify-btn{
    height: 42px;
    background: #000 !important;
    border:none;
    outline:none;     
   }
   .email-list{
    font-size:18px;
   }   
`;
export const DomainContainer = styled.div`
h1{
  margin-top: 30px 
}
.domain-list td{
  padding :25px 16px;
}
.Action-btn{
  cursor:pointer;
}
`;

export const AdddDomainContainter = styled.div`
.copy-button {
  display: flex !important;
  justify-content: center;
  align-items: center;
  column-gap: 8px;
  font-weight: 500;
  cursor: pointer;
}
.alert-message{
  background-color: #fff3cd;
  padding: 10px;
  margin-bottom: 20px;
  border-color: #ffeeba;
  color: #856404;
 }
.ant-input{
  height: 45px !important;
}
.ant-input-lg{
  height: 45px !important;
}
.input{
  height: 44px !important;
  .ant-input .ant-input-lg {
    height: 44px !important;
   }
}
.domain-keys{
margin-top:60px;
}
`;

export const InvalidError = styled.div` 
font-weight: 600;
font-size: 14px;
text-align: left;
color: rgb(186, 57, 57);
 margin-top:5px;
`

export const DetailCardContainer = styled.div`
position:relative;
  width: 95%;
  .anticon-right,
  .ant-collapse-arrow {
    // display: none !important;
  }
  .ant-collapse-item {
    border: none !important;
  }
  .ant-collapse-header {
    border-radius: 0;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 14px;
  }
  .editContainer {
    position: absolute;
    right: 6%;
    top: 23px;
    .anticon {
      font-size: 17px;
      color: #000;
      margin: 0px 10px;
      padding: 0px 5px;
    }
  }
  .collapse-card-style {
    display: flex;
    flex: initial;
    flex-direction: column;
    padding: 10px;
    border-radius: 6px;
    border-bottom: 1px solid rgb(223, 225, 228);
    box-shadow: rgb(0 0 0 / 3%) 0px 2px 5px;
    background-color: #ffffff;
    flex-basis: 31%;
    margin: 15px 15px 15px 0px;
    p {
      font-size: 13px;
      font-weight: 400;
    }
    .heading-txt {
      color: rgb(40, 42, 48);
      font-weight: 600;
      font-size: 15px;
      padding-right: 5px;
      line-height: 26px;
    }
    &:hover {
      box-shadow: rgb(0 0 0 / 9%) 0px 3px 12px;
    }

    .add_user_btn {
      font-weight: 500;
      font-size: 12px;
      text-transform: uppercase;
      height: 35px;
      padding: 10px 20px;
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      background: ${palette.APP_BRAND_YELLOW_COLOR};
      border-radius: 20px;
      color: rgb(0, 0, 0);
      text-shadow: none;
      border: 2px solid transparent;
    }
    .ant-btn.changeSMTP.ant-btn-primary {
      background: #000;
      border: #000;
      font-size: 10px;
      font-weight: 700;
      text-transform: uppercase;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 10px;
    }
    .ant-btn-primary:hover, .ant-btn-primary:focus {
      color: rgb(0, 0, 0);
      background: ${palette.APP_BRAND_YELLOW_COLOR};
      border-color:${palette.APP_BRAND_YELLOW_COLOR};
  }
  } 
  .center-screen{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const VerifyButton = styled.div`
position:${props => !props.delete && 'absolute'};
top: 50%;
left: 85%;
transform: ${props => !props.delete && 'translate(-50%, -50%)'};
background:${props => props.verify ? "#f9AA33" : "#0c0024"};
padding: 5px 15px;
border-radius: 20px;
color:white;
text-transform: capitalize;
display: flex;
gap: 8px;
align-items: center;
`;

export const ShortMsgChannelInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    font-size: 13px;
    letter-spacing: 0.25px;
    color: #8f8f8f;
  }
`;

export const ChannelInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  height: 240px;
  width: 28%;
  margin: 20px;
  padding: 20px;
  padding-top: 0px;
  box-shadow: rgb(0 0 0 / 15%) 0px 5px 15px 0px;
  i.anticon.anticon-phone,
  i.anticon.anticon-global {
    margin-right: 15px;
  }
  i.anticon.anticon-phone {
    transform: rotate(90deg);
  }
  i.anticon.anticon-edit {
    font-size: 12px;
  }
  i.anticon.anticon-check-circle {
    cursor: ${props => props.disabled && 'not-allowed'};
  }
  span {
    display: flex;
    align-items: center;
  }
  .detail {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-top: 25px;
    cursor: pointer;
    .ant-input {
      border: transparent;
      border-bottom: 1px solid #a39f9f;
      border-radius: 0;
      height: 20px;
      width: 75%;
      padding-left: 0;
    }
    .ant-input:focus {
      border-color: transparent;
      border-bottom: 1px solid #a39f9f;
      border-right-width: 1px !important;
      outline: 0;
      box-shadow: none;
    }
  }
  .number {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 150px;
    letter-spacing: 0.5px;
    color: #000;
  }
  .updateNumber {
    width: 25%;
    justify-content: space-between;
  }
`;

export const ChannelIcon = styled.div`
  .anticon {
    padding: 20px;
    background: ${props =>
    props.channel === 'whatsapp'
      ? '#d4ffd0'
      : props.channel === 'call'
        ? '#e6eeff'
        : props.channel === 'sms'
          ? '#fbe6e6'
          : '#fff'};
    border-radius: ${props =>
    props.channel === 'whatsapp'
      ? '150px 100px 125px 100px'
      : props.channel === 'call'
        ? '150px 200px 150px 150px'
        : props.channel === 'sms'
          ? '175px 175px 100px 175px '
          : '#fff'};

    margin: 20px;
    svg {
      display: inline-block;
      color: ${props =>
    props.channel === 'whatsapp'
      ? '#67c15e'
      : props.channel === 'call'
        ? '#7fa4f8'
        : props.channel === 'sms'
          ? '#E76464'
          : '#fff'};
      fill: ${props =>
    props.channel === 'whatsapp'
      ? '#67c15e'
      : props.channel === 'call'
        ? '#7fa4f8'
        : props.channel === 'sms'
          ? 'none'
          : '#fff'};
    }
  }
`;

export const ConfigKeys = styled.div`
  padding: 24px;
  padding-top: 0;
  column-gap: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  overflow: hidden auto;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const StorageConfirmationModal = styled(Modal)`
  font-family: 'Open Sans', sans-serif;
  .ant-modal-content {
    padding: 24px !important;
    p {
      text-align: center;
      font-weight: 600;
    }
  }
  .ant-modal-body {
    padding: 0 !important;
  }
  .ant-modal-footer {
    font-family: 'Open Sans', sans-serif;
    padding: 24px 0 0 0 !important;
  }
`;

export const ServiceInfoModal = styled(Modal)`
  font-family: 'Open Sans', sans-serif;
  .ant-modal-body {
    padding: 0 25px;
  }
  .ant-form-explain,
  .ant-form-extra {
    padding-top: 6px;
  }
  .ant-modal-footer .ant-btn {
    font-family: 'Open Sans' !important;
  }
`;

export const StyledAlertsAndNotifications = styled.div`
  .anticon.anticon-search.ant-input-search-icon, .anticon.anticon-close.ant-select-remove-icon {
    display: none;
  }
  .ant-select-selection--multiple .ant-select-selection__choice {
    border-radius: 15px;
    padding: 0;
  }
  .ant-select-lg .ant-select-selection--multiple .ant-select-selection__rendered li {
    height: auto;
    line-height: normal;
  }
  .ant-select-selection--multiple .ant-select-selection__rendered {
    margin-bottom: 0;
    margin-left: 0;
  }
  .ant-input {
    width: 350px;
  }
  .anticon.anticon-delete, .delete-loading-icon.anticon.anticon-loading {
    height: 36px;
    width: 36px;
    font-size: 13px;
    color: red;
    background: #FBCEB1;
    border-radius: 0 15px 15px 0;
    display: grid;
    place-content: center;
    margin-left: 12px;
  };
  .ant-select-selection--multiple .ant-select-selection__choice__content {
    display: flex;
    align-items: center;
    background: #F0F8FF;
    padding-left: 12px;
  }
  .ant-select ul {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  };
  .sub-heading-text {
    font-weight: 600;
    padding-bottom: 6px;
  }
  .input-container {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
  }
  .threshold-input {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .threshold-saving {
    font-size: 15px;
    font-style: italic;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const animateOutCenter = keyframes`
0% {
    clip-path: circle(125%);
  }
  40% {
    clip-path: circle(40%);
  }
  100% {
    clip-path: circle(0%);
  }
`;

const animateInCenter = keyframes`
 0% {
    clip-path: circle(0%);
  }
  40% {
    clip-path: circle(40%);
  }
  100% {
    clip-path: circle(125%);
  }
`;

export const Nav = styled.nav`
  background: #191919;
  width: 100%;
  height: 3em;
  border-radius: 2em;
  padding: 0 2em;
  // box-shadow: 0 1em 1em rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  max-width: fit-content;
`;

export const NavLinks = styled.ul`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 30px;
`;

export const NavLink = styled.li`
  display: inline-block;
  span {
    color: #fff;
    font-size: 1rem;
    opacity: 0.5;
    transition: opacity 0.3s;
    cursor: pointer;

    ${({ active, color }) =>
      active &&
      css`
        opacity: 1;
        color: ${color};
        text-shadow: 0 0 15px ${color}, 0 0 30px ${color}, 0 0 45px ${color}, 0 0 60px ${color};
      `}
  }
`;

export const NavLight = styled.div`
  position: absolute;
  top: 0;
  left: ${({ position }) => position}px;
  background-color: ${({ color }) => color};
  width: ${({ width }) => width}px;
  height: 0.4em;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  transition: left 0.3s ease, width 0.3s ease, background-color 0.3s ease;

  &::before {
    content: "";
    width: ${({ beforeWidth }) => beforeWidth}px;
    height: 7em;
    position: absolute;
    top: 0.4em;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.3) -50%, rgba(255, 255, 255, 0) 90%);
    clip-path: polygon(30% 0, 70% 0, 100% 100%, 0% 100%);
  }
`;

export const TabBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 98%;
  padding: 50px 25px 25px 25px;
  border-radius: 15px;
  margin-top: -25px;
  // box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  animation: ${({ isVisible }) =>
    isVisible
      ? css`
          ${fadeIn} 0.3s ease-in-out
        `
      : 'none'};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;

  .config-link-container{
    display: inline-block;
    text-align: center;
    border-radius: 10px;
    border: 1px solid;
    padding: 5px 10px;
    .config-link{
     color:#1890ff;
     cursor: pointer;
    }
  }
  
  .ds-switch {
    height: 40px;

    .ant-switch {
      height: 40px;
    }

    .ant-switch-checked .ant-switch-inner {
      margin-right: 50px;
      margin-left: 15px;
    }

    .ant-switch-checked {
      background-color: #ffeb3b !important;
    }

    .ant-switch::after {
      width: 36px;
      height: 36px;
    }

    .ant-switch-checked::after {
      width: 36px;
      height: 36px;
    }
  }

  .ds-switch .ant-switch-inner {
    color: #000;
    font-size: 12px;
    font-family: ${palette.FONT_FAMILY_LANDPAGE} !important;
    font-weight: 700;
    margin-right: 15px;
    margin-left: 50px;
  }

  .ds-switch.ant-switch-checked .ant-switch-inner {
    margin-right: 50px;
    margin-left: 15px;
  }

  .ds-switch.ant-switch-checked {
    background-color: #ffeb3b !important;
  }

  .ds-switch.ant-switch::after {
    width: 36px;
    height: 36px;
  }

  .ds-switch.ant-switch-checked::after {
    width: 36px;
    height: 36px;
  }
}`;

export const Wrapper = styled.div`
  background-color: #ececec;
  padding: 0;
  margin: 0;
  height: 85%;
  width: 90%
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  gap:30px;
  animation: ${({enableSSO})=> (enableSSO ? css`2.5s cubic-bezier(.25, 1, .30, 1) ${animateOutCenter} both` : css`2.5s cubic-bezier(.25, 1, .30, 1) ${animateInCenter} both`)};

  p {
   font-size: 20px;
  }
`;

export const LinkContainer = styled.div`
display:flex;
flex-direction: column;
font-size:18px;
gap: 20px;
border-radius: 10px;
border: 1px solid;
padding: 10px;
margin-bottom: 20px;
text-align: center;
`;

export const ConfigLink = styled.p`
  display: flex;
  justify-content: center;
  cursor: pointer;
  font-size: 18px !important;
  align-items: center;
  gap: 5px;
  color: #1890ff;
`;

export const LinkWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;
  flex-wrap: wrap;
`;

export const StyledCheckboxWrapper = styled.div`
  position: relative;
  height: 200px;
  width: 200px;
`;

export const StyledCheckbox = styled.input`
  height: 200px;
  width: 200px;
  -webkit-appearance: none;
  box-shadow: 
    -10px -10px 15px rgba(255, 255, 255, 0.5),
    10px 10px 15px rgba(70, 70, 70, 0.12);
  position: absolute;
  border-radius: 50%;
  border: 20px solid #ececec;
  outline: none;
  cursor: pointer;
  transition: box-shadow 0.3s ease;

  &:checked {
    box-shadow: 
      -10px -10px 15px rgba(255, 255, 255, 0.5),
      10px 10px 15px rgba(70, 70, 70, 0.12),
      inset -10px -10px 15px rgba(255, 255, 255, 0.5),
      inset 10px 10px 15px rgba(70, 70, 70, 0.12);
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 70px;
  color: ${(props) => (props.checked ? "#15e38a" : "#7a7a7a")};
  transition: color 0.3s ease;
  cursor: pointer;
`;

export const TableTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const SubTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
`;
const widthAnimation = keyframes`
  to {
    width: 70%;
  }
`;
const fadeInAnim = keyframes`
  to {
    opacity: 1;
    transform: translateY(0%);
  }
`;

export const ExternalServiceStyles = styled.div`
  display: flex;
  gap: 24px;
  padding: 24px 3px;
  align-items: flex-start;
  flex-wrap: wrap;
`;

export const ServiceCard = styled.div`
  position: relative;
  width: ${props => props.active ? '400px' : '240px'};
  height: ${props => props.formHeight};  
  border-radius: 12px;  
  box-shadow: ${props => !props.configured ? 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px' 
    : '#f9f871 0px 1px 3px 0px, aquamarine 0px 0px 0px 1px'};
  transition: all 0.3s linear;
  z-index: 1;
  overflow: hidden;
  font-family: Open Sans;
  .configured {
    position: absolute;
    top: 0;
    right: 0;
    background: #f9f871;
    color: #000;
    padding: 5px 10px;
    font-size: 13px;
    font-style: italic;
    font-weight: bold;
    border-radius: 0 0 0 12px;
    font-family: Open Sans;
  }
  .service-card {
    padding: 18px;  
    background: ${props => props.configured ? '#fcfcfc' : '#F0F8FF'};
  }
  .service-card-header {
    display: flex;
    align-items: center;
    gap: 8px;
    h1 {
      font-size: 16px;
      font-weight: bold;
    }
  }
  .button-wrapper {
    margin-top: 24px;
    width: 100%;
    display: flex;
    justify-content: flex-end; 
  }
  .icon-wrapper {
    background: #DAD8EB;
    color: #000;
    height: 40px;
    width: 40px;
    display: grid;
    place-items: center;
    border-radius: 150px 200px 150px 150px;
  }
  .ant-form-item-control {
    line-height: 30px;
  }
  .ant-form-item {
    margin-bottom: 12px;
  }
  .ant-btn, .ant-btn:hover {
    border: 1px solid #4c7782;
    background: ${props => props.active ? 'black' : 'transparent'};
    color: ${props => props.active ? 'white' : '#4c7782'};
    font-weight: bold;
    font-family: Open Sans !important;
  }
`;

export const ConfigExternalForm = styled.div`
  padding: 24px;
  .services-form-footer {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 16px;
  }
  .configure-button {
    width: 40%;
    min-height: 36px;
    border-radius: 24px;
    opacity: 0;
    transform: translateY(-150%);
    background: #4c7782;
    animation: ${fadeInAnim} 0.3s linear forwards,
    ${widthAnimation} 0.3s 0.3s linear forwards;
  }
  .fade-enter {
    opacity: 0;
    transform: translateX(100%);
  }
  .fade-enter-active {
    opacity: 1;
    transform: translateX(0%);
  }
  .fade-exit {
    opacity: 1;
    transform: translateX(0%);
  }
  .fade-exit-active {
    opacity: 0;
    transform: translateX(-100%);
  }
  .fade-enter-active,
  .fade-exit-active {
    transition: opacity 500ms, transform 500ms;
  }
`;

export const ToggleFeatures = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  .toggle-container {
    margin-left: 1px;
    padding: 18px;
    max-width: 750px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
    border-radius: 12px;
  }
  h6 {
    font-weight: 600;
    margin-bottom: 6px;
  }
`;
